export const buildBBox = ({latitude, longitude}) => (
    {
        sw: {lng: longitude - 0.4, lat: latitude - 0.3},
        ne: {lng: longitude + 0.4, lat: latitude + 0.3},
    }
);
